module.exports = __webpack_public_path__ + "static/media/pipe-riser.c044fb7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/pipes/PipeAccessories/pipe-riser.png
// module id = 2032
// module chunks = 0